/* eslint-disable no-useless-constructor */
import * as React from 'react';
import HelmetManager from '../../components/_common/helmet-manager';
import { getText, getConfig, getPageTextsSection } from '../../helpers';
import HeroProductFinder from '../../components/hero-product-finder';
import TileCarousel from '../../components/_common/tile-carousel';
import ProductPreviewSection from '../../components/product-preview-section';
import SolutionTile from '../../components/tile/solution-tile';
import ResearchSection from '../../components/research-section';
import HomepageContent from '../../components/homepage-content';
import PageLoaded from '../../components/_common/page-loaded';
import APIManager from '../../utilities/api-manager';
import SPGVariables from '../../utilities/spg-variables';
import Loader from '../../components/_common/loader';

const carouselOptions = getConfig('routes.homepage.carouselOptions');

const metaDataText = getText('pages.home.metaData');
const recommendationTitle = getText('pages.home.recommendationTitle');

const spgVariables = SPGVariables();
const trendingData = spgVariables.TRENDINGDATASETS as number[];

const pageText = getConfig('pagetext.homepage');
const companyTypeList = getText('pages.home.companyType');
const emptySearchResult = getConfig('pagetext.datasets');


export default class HomePage extends React.Component<PageProps & HomePageProps & HomePageActions, HomePageState> {
    public constructor(props: PageProps & HomePageProps & HomePageActions) {
        super(props);
        this.state = {
            searchInputFocused: false,
            openSearchDatasets: [],
            isHelmetManagerRendered: false
            // Do not remove this! used by nullable state
        };
    }

    public componentDidMount() {
        const { fetchResearchLinks } = this.props;

        fetchResearchLinks();

        this.getHomepageCompanyTypes();
        setTimeout(() => {
            this.setState({
                isHelmetManagerRendered: true
            });
        }, 0);
    }

    public componentDidUpdate() {
        const { homepageCompanyTypes, openSearchDatasets } = this.state;
        if (homepageCompanyTypes === undefined) this.getHomepageCompanyTypes();
        // if (openSearchDatasets === undefined || openSearchDatasets.length === 0) this.fetchOpenSearchDatasets();
    }

    public getHomepageCompanyTypes = () => {
        const { isLoggedIn, keyOnlineUserCompanyType } = this.props;
        if (isLoggedIn && keyOnlineUserCompanyType !== undefined) {
            APIManager.getHomepageCompanyTypes(keyOnlineUserCompanyType).then(response => {
                const homepageCompanyTypes = response.data.map(dataset => {
                    if (dataset.KeyMarketplaceDataset) return dataset.KeyMarketplaceDataset;
                    if (dataset.KeyMarketplaceDatasetBundle) return dataset.KeyMarketplaceDatasetBundle;
                    if (dataset.KeyPlatformService) return dataset.KeyPlatformService;
                    return 0;
                });
                const companyTypeName = companyTypeList.filter(
                    (company: { KeyOnlineUserCompanyType: number; Value: string }) => company.KeyOnlineUserCompanyType === keyOnlineUserCompanyType
                );
                const homepageCompanyTypeTitle = (companyTypeName.length > 0 && recommendationTitle + companyTypeName[0].Value) || '';

                this.setState({ homepageCompanyTypes, homepageCompanyTypeTitle });
            }).catch(() => {
                this.setState({ homepageCompanyTypes: [] as (number | string)[] });
            });
        }
    };

    public render() {
        const {
            researchData,
            featuredData,
            alternativeData,
            pageTextsData,
            solutions,
            keyPage,
            startDate,
            isLoggedIn,
            keyOnlineUserCompanyType,
            featuredBlueprintData
        } = this.props;
        const { homepageCompanyTypes, homepageCompanyTypeTitle } = this.state;
        const articleLinks = researchData.map((item: ResearchLinkItem) => {
            return {
                url: item.customLocalUrl,
                title: item.customSegment && item.customSegment.length > 0 && item.customSegment.join(', '),
                text: item.title
            };
        });

        const headerSection = getPageTextsSection(pageText.headerSection, pageTextsData);
        const solutionSection = getPageTextsSection(pageText.solutionsSection, pageTextsData);
        const researchSection = getPageTextsSection(pageText.researchSection, pageTextsData);
        const dataPhilosophySection = getPageTextsSection(pageText.dataPhilosophySection, pageTextsData);
        const emptySearchSection = getPageTextsSection(emptySearchResult.noResultSection.noresults, pageTextsData);

        const hasSolutions = solutions.length > 0;
        const hasFeaturedData = featuredData.length > 0;
        const hasCompanyTypes = homepageCompanyTypes && homepageCompanyTypes.length > 0;
        const hasArticleLinks = articleLinks.length;
        const hasFeaturedBlueprints = featuredBlueprintData.length > 0;

        const setSearchInputFocused = (value: boolean) => {
            this.setState({
                searchInputFocused: value
            });

        };

        const { searchInputFocused, isHelmetManagerRendered } = this.state;

        const ready = hasSolutions && (hasFeaturedData || isLoggedIn) && hasSolutions;
        return (
            <article className="page page--noMargin homepage">
                { isHelmetManagerRendered && <HelmetManager metaData={metaDataText} /> }
                <HeroProductFinder
                    videoId={headerSection.linkUrl}
                    title={headerSection.title}
                    snippet={headerSection.content}
                    emptySearchSection={emptySearchSection}
                    setSearchInputFocused={setSearchInputFocused}
                />
                {!searchInputFocused && ((!ready && <Loader minHeight="50vh" />) || (
                    <>
                        <hr />
                        {trendingData && trendingData.length > 0 && (
                            <TileCarousel
                                dataIds={trendingData}
                                title={getText('generic.trendingDatasets')}
                                slickOptions={carouselOptions}
                                showMoreLink
                                fullBleed
                            />
                        )}
                        {isLoggedIn && keyOnlineUserCompanyType !== undefined && hasCompanyTypes ? (
                            <TileCarousel
                                dataIds={homepageCompanyTypes || []}
                                title={homepageCompanyTypeTitle}
                                slickOptions={carouselOptions}
                                showMoreLink
                                fullBleed
                            />
                        ) : (
                            hasFeaturedData && (
                                <TileCarousel
                                    dataIds={featuredData}
                                    title={getText('generic.featuredDatasets')}
                                    slickOptions={carouselOptions}
                                    showMoreLink
                                    fullBleed
                                />
                            )
                        )}
                        {/* {hasAlternativeData && (
                            <TileCarousel
                                dataIds={alternativeData}
                                title={getText('generic.alternativeDatasets')}
                                slickOptions={carouselOptions}
                                showMoreLink
                                fullBleed
                                queryString={`?filters=${encodeURIComponent(`{"category":["${getText('generic.alternative')}"]}`)}`}
                            />
                        )} */}
                        {hasFeaturedBlueprints && (
                            <TileCarousel
                                dataIds={featuredBlueprintData}
                                title={getText('generic.blueprints')}
                                slickOptions={carouselOptions}
                                showMoreLink-={false}
                                fullBleed
                                showMoreBlueprints
                            />
                        )}
                        {hasSolutions && (
                            <>
                                <hr />
                                <ProductPreviewSection
                                    title={solutionSection.title}
                                    description={solutionSection.content}
                                    linkText={solutionSection.linkText}
                                    linkUrl={solutionSection.linkUrl}
                                >
                                    {solutions.map((solution: APISolution) => (
                                        <SolutionTile key={solution.KeyPlatformService} solution={solution} />
                                    ))}
                                </ProductPreviewSection>
                            </>
                        )}
                        <hr />
                        {hasArticleLinks && (
                            <ResearchSection
                                snippet={`${researchSection.title}${researchSection.content}`}
                                articleLinks={articleLinks}
                                readMoreLink={researchSection.linkUrl}
                                linkText={researchSection.linkText}
                            />
                        )}
                        <HomepageContent snippet={`${dataPhilosophySection.title}${dataPhilosophySection.content}`} />
                        {hasSolutions && <PageLoaded keyPage={keyPage} startDate={startDate} />}
                    </>
                ))}
            </article>
        );
    }
}
